import { render, staticRenderFns } from "./PopupLoadBoard987.vue?vue&type=template&id=30441d30&scoped=true"
import script from "./PopupLoadBoard987.vue?vue&type=script&lang=js"
export * from "./PopupLoadBoard987.vue?vue&type=script&lang=js"
import style0 from "./PopupLoadBoard987.vue?vue&type=style&index=0&id=30441d30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30441d30",
  null
  
)

export default component.exports